import React from 'react';
import {useToast} from '../context/ToastContext';
import {colors} from '../theme/colors';

const Toast = ({toast}) => {
  const {removeToast} = useToast();

  const getToastStyles = () => {
    const baseStyles = {
      minWidth: '300px',
      maxWidth: '90%',
      padding: '16px 20px',
      borderRadius: '12px',
      boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      animation: 'slideInFromBottom 0.3s ease forwards',
      position: 'relative',
      zIndex: 10000,
    };

    switch (toast.type) {
      case 'success':
        return {
          ...baseStyles,
          backgroundColor: colors.surface,
          border: `1px solid ${colors.success}`,
          color: colors.textPrimary,
        };
      case 'error':
        return {
          ...baseStyles,
          backgroundColor: colors.surface,
          border: `1px solid ${colors.error}`,
          color: colors.textPrimary,
        };
      case 'warning':
        return {
          ...baseStyles,
          backgroundColor: colors.surface,
          border: `1px solid ${colors.warning}`,
          color: colors.textPrimary,
        };
      default: // info
        return {
          ...baseStyles,
          backgroundColor: colors.surface,
          border: `1px solid ${colors.primary}`,
          color: colors.textPrimary,
        };
    }
  };

  const getIcon = () => {
    switch (toast.type) {
      case 'success':
        return '✓';
      case 'error':
        return '✕';
      case 'warning':
        return '⚠';
      default:
        return 'ℹ';
    }
  };

  const getIconColor = () => {
    switch (toast.type) {
      case 'success':
        return colors.success;
      case 'error':
        return colors.error;
      case 'warning':
        return colors.warning;
      default:
        return colors.primary;
    }
  };

  return (
    <div 
      style={getToastStyles()} 
      onClick={() => removeToast(toast.id)}
      role="alert"
      aria-live={toast.type === 'error' ? 'assertive' : 'polite'}
      aria-atomic="true">
      <div
        style={{
          width: '24px',
          height: '24px',
          borderRadius: '50%',
          backgroundColor: getIconColor(),
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: colors.textOnPrimary,
          fontSize: '14px',
          fontWeight: 'bold',
          flexShrink: 0,
        }}
        aria-hidden="true">
        {getIcon()}
      </div>
      <div style={{flex: 1, fontSize: '14px', lineHeight: 1.5}}>{toast.message}</div>
      <button
        onClick={(e) => {
          e.stopPropagation();
          removeToast(toast.id);
        }}
        aria-label={`Close ${toast.type} notification`}
        type="button"
        style={{
          background: 'none',
          border: 'none',
          color: colors.textTertiary,
          fontSize: '20px',
          cursor: 'pointer',
          padding: '0',
          width: '24px',
          height: '24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}>
        <span aria-hidden="true">×</span>
      </button>
    </div>
  );
};

const ToastContainer = () => {
  const {toasts} = useToast();

  if (toasts.length === 0) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 10000,
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        alignItems: 'center',
        pointerEvents: 'none',
        width: '100%',
        maxWidth: '500px',
        padding: '0 20px',
      }}>
      {toasts.map(toast => (
        <div key={toast.id} style={{pointerEvents: 'auto', width: '100%'}}>
          <Toast toast={toast} />
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;

